let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2L330")).then(() => parcelRequire('3woZX'));